import { render, staticRenderFns } from "./UserApplyRecordList.vue?vue&type=template&id=8882f676&scoped=true"
import script from "./UserApplyRecordList.vue?vue&type=script&lang=js"
export * from "./UserApplyRecordList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8882f676",
  null
  
)

export default component.exports